// extracted by mini-css-extract-plugin
module.exports = {"Projects":"Projects_Projects__2EuW9","ProjectsInner":"Projects_ProjectsInner__1Rjfb"};